import {
  IonApp,
  IonContent,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonLoading,
  IonPage,
} from "@ionic/react";
import OrderStatus from "components/mobile-components/OrderList/OrderStatus";
import ProductList from "components/mobile-components/products/ProductList";
import SellerFilter from "components/mobile-components/products/SellerFilter";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { setLocation } from "redux/container/userSlice";
import Supplier from "services/Supplier";
import TitleNSearch from "components/mobile-components/Common/TitleNSearch";
import { fetchOrder, searchOrder } from "redux/container/orderSlice";
import { useDebounce } from "use-debounce";
import ProductsTab from "components/mobile-components/products/ProductsTab";
import Product from "services/Product";

export default function SellerListPage() {
  const { category } = useParams();
  const dispatch = useDispatch();
  const [sellerData, setSellerData] = useState([]);
  const [pageCount, setPageCount] = useState(2);
  const [loading, setLoading] = useState(true);
  const [searchQ, setSearchQ] = useState("");
  const [hasMoreData, setHasMoreData] = useState(true);
  const [reachedEnd, setReachedEnd] = useState(false);
  const [orderStatus, setOrderStatus] = useState([]);
  const [orderInitLoaded, setOrderInitLoaded] = useState(false);
  const [debouncedSearchQ] = useDebounce(searchQ, 2000);
  const ekkLanguage = useSelector((state) => state.lan.lan);
  const location = useSelector(
    (state) => state.user?.locationData?.coordinates
  );
  const filterMode = useSelector((state) => state.supplier.data); // "purchaseOrder" | "nearbySeller" | "allSeller" | "international" | "products"
  const orderListPage = useSelector((state) => state.order.page);

  const settings = {
    nameShow: false,
    skuShow: false,
    priceShow: false,
    oldPriceShow: false,
    distShow: true,
    profitShow: false,
    sellPriceShow: false,
    supplierNameShow: true,
    newPriceShow: false,
    defaultImage: "/assets/images/supplier_default.png",
    placeHolder: ekkLanguage.seeMoreProduct.supplierSearchPlaceholder,
    nearBySupplierNotFound: ekkLanguage.sellerList.nearBySupplierNotFound,
    supplierNotFound: ekkLanguage.sellerList.supplierNotFound,
  };
  // * ---------------- Product List Logic ----------------
  let getProductList = async () => {
    setPageCount(2);
    setLoading(true);
    let response = await Product.productList();
    if (response.status === 200) {
      setLoading(false);
      setSellerData(response.results);
    } else {
      setLoading(false);
    }
  };
  useEffect(() => {
    getProductList();
  }, []);
  let getTermToProduct = async () => {
    setPageCount(2);
    setLoading(true);
    let response = await Product.productSearch(searchQ);
    if (response.success) {
      setLoading(false);
      setSellerData(response?.data);
    } else {
      setLoading(false);
    }
  };
  // * ---------------- Order List Logic ----------------
  const getInitOrderList = async () => {
    setPageCount(2);
    setLoading(true);
    const response = await dispatch(fetchOrder("", orderListPage));
    setLoading(false);
    setOrderInitLoaded(true);
  };

  const getMoreOrders = async () => {
    if (hasMoreData) {
      const response = await dispatch(fetchOrder(orderStatus, orderListPage));
      if (!response.data?.length) setHasMoreData(false);
    }
  };

  const getOrderSearch = async () => {
    setPageCount(2);
    setLoading(true);
    if (searchQ.trim() !== "") {
      setLoading(true);
      await dispatch(searchOrder(searchQ, 500, 1));
      setLoading(false);
    }
  };

  // * ---------------- Seller List Logic ----------------
  const getSupplierList = async () => {
    setPageCount(2);
    setLoading(true);
    const response = searchQ
      ? await Supplier.supplierSearch(searchQ, location[1], location[0])
      : await Supplier.getSupplierList(location[1], location[0]);

    if (response.status === 200) {
      setSellerData(response.results);
    }
    setLoading(false);
  };

  const getAllSupplierList = async () => {
    setPageCount(2);
    setLoading(true);
    const response = searchQ
      ? await Supplier.allSupplierSearch(location[1], location[0], searchQ)
      : await Supplier.getAllSupplierList(location[1], location[0]);

    if (response.status === 200) {
      setSellerData(response.results);
    }
    setLoading(false);
  };

  const getInternationalSupplierList = async () => {
    setPageCount(2);
    setLoading(true);
    const response = searchQ
      ? await Supplier.internationalSupplierSearch(searchQ)
      : await Supplier.getInternationalSuppliers();

    if (response.status === 200) {
      setSellerData(response.results);
    }
    setLoading(false);
  };

  const singleSellerSearch = async () => {
    setPageCount(2);
    setLoading(true);
    let response;
    if (filterMode === "nearbySeller") {
      response = await Supplier.supplierSearch(
        searchQ,
        location[1],
        location[0]
      );
    } else if (filterMode === "allSeller") {
      response = await Supplier.allSupplierSearch(
        location[1],
        location[0],
        searchQ
      );
    } else if (filterMode === "international") {
      response = await Supplier.internationalSupplierSearch(searchQ);
    }
    if (response.status === 200) {
      setSellerData(response.results);
    }
    setLoading(false);
  };

  const loadMoreSeller = async () => {
    if (!hasMoreData) return;
    let response;
    if (searchQ) {
      if (filterMode === "nearbySeller") {
        response = await Supplier.supplierSearch(
          searchQ,
          location[1],
          location[0],
          pageCount
        );
      } else if (filterMode === "allSeller") {
        response = await Supplier.allSupplierSearch(
          location[1],
          location[0],
          searchQ,
          pageCount
        );
      } else if (filterMode === "international") {
        response = await Supplier.internationalSupplierSearch(
          searchQ,
          pageCount
        );
      } else if (filterMode === "products") {
        response = await Product.productSearch(searchQ, pageCount);
      }
    } else {
      if (filterMode === "nearbySeller") {
        response = await Supplier.getSupplierList(
          location[1],
          location[0],
          pageCount
        );
      } else if (filterMode === "allSeller") {
        response = await Supplier.getAllSupplierList(
          location[1],
          location[0],
          pageCount
        );
      } else if (filterMode === "international") {
        response = await Supplier.getInternationalSuppliers(pageCount);
      } else if (filterMode === "products") {
        response = await Product.productList(pageCount);
      }
    }

    if (response.status === 200) {
      setPageCount((prev) => prev + 1);
      setSellerData((prev) => [...prev, ...response.results]);
    } else {
      setHasMoreData(false);
    }
  };

  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((p) => {
        dispatch(
          setLocation({
            type: "Point",
            coordinates: [p.coords.latitude, p.coords.longitude],
          })
        );
      });
    } else {
      toast.error("Geolocation is not supported by this browser.");
    }
  };

  useEffect(() => {
    getLocation();
  }, []);

  useEffect(() => {
    if (filterMode === "purchaseOrder") {
      if (debouncedSearchQ.trim()) {
        getOrderSearch();
      } else {
        getInitOrderList();
      }
    } else if (filterMode === "nearbySeller") {
      if (debouncedSearchQ === "") {
        getSupplierList();
      } else {
        singleSellerSearch();
      }
    } else if (filterMode === "allSeller") {
      if (debouncedSearchQ === "") {
        getAllSupplierList();
      } else {
        singleSellerSearch();
      }
    } else if (filterMode === "international") {
      if (debouncedSearchQ === "") {
        getInternationalSupplierList();
      } else {
        singleSellerSearch();
      }
    } else if (filterMode === "products") {
      if (debouncedSearchQ === "") {
        getProductList();
      } else {
        getTermToProduct();
      }
    }
  }, [debouncedSearchQ, filterMode]);

  const deleteQueryHandler = () => {
    setSearchQ("");
    setPageCount(2);
    if (filterMode === "purchaseOrder") {
      getInitOrderList();
    } else if (filterMode === "nearbySeller") {
      getSupplierList();
    } else if (filterMode === "allSeller") {
      getAllSupplierList();
    } else if (filterMode === "international") {
      getInternationalSupplierList();
    } else if (filterMode === "products") {
      getProductList();
    }
  };
  return (
    <IonApp>
      <IonPage>
        <IonContent scrollEvents={true}>
          <TitleNSearch
            title={
              filterMode === "purchaseOrder"
                ? "Purchase"
                : filterMode === "products"
                ? "Product List"
                : "Supplier List"
            }
            placeholder={
              filterMode === "purchaseOrder"
                ? "Search Order"
                : filterMode === "products"
                ? "Search Product"
                : settings.placeHolder
            }
            searchQ={searchQ}
            setSearchQ={setSearchQ}
            fetchSearchData={
              filterMode === "purchaseOrder"
                ? getOrderSearch
                : filterMode === "products"
                ? getTermToProduct
                : singleSellerSearch
            }
            initData={
              filterMode === "purchaseOrder" ? getInitOrderList : undefined
            }
            deleteQuery={deleteQueryHandler}
            inputType={filterMode === "purchaseOrder" ? "number" : "text"}
          />

          <section className="pt-14">
            <div className="pt-4 px-4 pb-4">
              <SellerFilter
                ekkLanguage={ekkLanguage}
                setReachedEnd={setReachedEnd}
                setHasMoreData={setHasMoreData}
              />
            </div>

            {loading && (
              <IonLoading
                isOpen={true}
                message={ekkLanguage.orderList.loader}
              />
            )}

            {!loading && filterMode === "purchaseOrder" ? (
              <OrderStatus
                setOrderStatus={setOrderStatus}
                loading={loading}
                setLoading={setLoading}
                setReachedEnd={setReachedEnd}
                setHasMoreData={setHasMoreData}
              />
            ) : filterMode === "products" ? (
              <ProductsTab products={sellerData} loading={loading} />
            ) : (
              <ProductList
                locatedSeller={filterMode}
                loading={loading}
                productData={sellerData}
                category={category}
                settings={settings}
                link={"supplier-details"}
                ekkLanguage={ekkLanguage}
                identity="seller"
              />
            )}
          </section>

          <IonInfiniteScroll
            onIonInfinite={(ev) => {
              if (reachedEnd) {
                ev.target.complete();
                return;
              }
              filterMode === "purchaseOrder"
                ? getMoreOrders()
                : loadMoreSeller();
              setTimeout(() => {
                ev.target.complete();
                if (!hasMoreData) setReachedEnd(true);
              }, 500);
            }}
          >
            <IonInfiniteScrollContent
              loadingText={ekkLanguage.orderList.loader}
              loadingSpinner={hasMoreData ? "bubbles" : null}
            />
          </IonInfiniteScroll>
        </IonContent>
      </IonPage>
    </IonApp>
  );
}
